import { render, staticRenderFns } from "./basereclamos.vue?vue&type=template&id=8e2bcfea"
import script from "./basereclamos.vue?vue&type=script&lang=js"
export * from "./basereclamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports